<template>
    <v-list-item
        :active="false"
        class="opinion-item tw-bg-white"
        :data-id="post.id"
        :ripple="false"
        :to="{
            name: 'OpinionPage',
            params: { id: post.id },
        }">
        <v-list-item-subtitle
            class="tw-mb-2 tw-text-xs tw-opacity-100 sm:tw-text-sm tw-font-title"
            v-html="post.authorName">
        </v-list-item-subtitle>
        <v-list-item-title class="tw-flex tw-flex-row tw-items-center tw-gap-3 tw-text-wrap tw-font-title tw-text-sm tw-font-medium tw-leading-[1.15] tw-text-dark">
            <Quote class="tw-size-[22px] tw-flex-shrink-0" />
            <p
                class="tw-line-clamp-2"
                v-html="post.title"></p>
        </v-list-item-title>
        <v-list-item-subtitle class="tw-mt-auto tw-pt-2 tw-text-xxs sm:tw-text-xs">
            {{ relativeDate }}
        </v-list-item-subtitle>

        <template #prepend>
            <div class="tw-mr-3 tw-flex tw-size-[75px] tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-black tw-bg-gray-300">
                <v-avatar
                    class="tw-size-[67px]"
                    rounded="full">
                    <v-img :src="post.authorImageUrl || undefined"></v-img>
                </v-avatar>
            </div>
        </template>
    </v-list-item>
</template>

<script setup lang="ts">
    import { getRelativeDate } from '@/composables/usePost';
    import type { IOpinion } from '@/contentTypes';

    const props = defineProps<{
        post: Partial<IOpinion>;
    }>();

    const relativeDate = computed(() => {
        return getRelativeDate(props.post.date);
    });
</script>

<style lang="scss">
    .opinion-item {
        .v-list-item__content {
            height: 100%;
            display: flex;
            flex-direction: column;
        }
        .v-list-item__prepend {
            margin-bottom: auto;
        }
    }
</style>
